import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "avance-panel" }
const _hoisted_2 = {
  key: 0,
  class: "estado-msg"
}
const _hoisted_3 = {
  key: 1,
  class: "estado-msg error"
}
const _hoisted_4 = { class: "cabecera" }
const _hoisted_5 = { class: "meta" }
const _hoisted_6 = { class: "acciones" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "resumen-global" }
const _hoisted_11 = { class: "gp" }
const _hoisted_12 = { class: "gp-info" }
const _hoisted_13 = { class: "gp-sub" }
const _hoisted_14 = { class: "gf-row" }
const _hoisted_15 = { class: "gf" }
const _hoisted_16 = { class: "gf-top" }
const _hoisted_17 = { class: "gf-num" }
const _hoisted_18 = { class: "barra-fondo mini" }
const _hoisted_19 = { class: "gf" }
const _hoisted_20 = { class: "gf-top" }
const _hoisted_21 = { class: "gf-num" }
const _hoisted_22 = { class: "barra-fondo mini" }
const _hoisted_23 = { class: "gf" }
const _hoisted_24 = { class: "gf-top" }
const _hoisted_25 = { class: "gf-num" }
const _hoisted_26 = { class: "barra-fondo mini" }
const _hoisted_27 = { class: "nota" }
const _hoisted_28 = { class: "contenedor-tabla" }
const _hoisted_29 = { class: "lista-tabla" }
const _hoisted_30 = { class: "ctr col-num" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "pill p-rojo"
}
const _hoisted_33 = { class: "ctr" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "barra-txt" }
const _hoisted_36 = { class: "ctr" }
const _hoisted_37 = { class: "ctr" }
const _hoisted_38 = { class: "ctr" }
const _hoisted_39 = { class: "ctr semaforo" }
const _hoisted_40 = {
  key: 0,
  class: "pill p-verde"
}
const _hoisted_41 = {
  key: 1,
  class: "pill p-ambar"
}
const _hoisted_42 = {
  key: 2,
  class: "pill p-rojo"
}
const _hoisted_43 = {
  key: 3,
  class: "nota"
}
const _hoisted_44 = { class: "ctr" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "nota"
}
const _hoisted_47 = {
  key: 0,
  class: "fila-pendientes"
}
const _hoisted_48 = { colspan: "9" }
const _hoisted_49 = { class: "pendientes-detalle" }
const _hoisted_50 = { class: "caract" }
const _hoisted_51 = { key: 0 }

import { ref, computed, watch, onMounted } from 'vue'
import { getAvanceProcesoService, descargarPdfAvanceService, type AvanceProceso, type AvanceFactor } from '@/services/AvanceProcesoService'
import { exportarExcel, exportarCSV, type Celda } from '@/utils/exportUtils'

interface FactorConOrdinal extends AvanceFactor {
  ordinal?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AvanceFactorPanel',
  props: {
    idEjecucion: {}
  },
  setup(__props: any) {

/**
 * Panel de avance por factor.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

function formatOrdinal(ordinal: string): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

const props = __props

const avance = ref<AvanceProceso | null>(null)
const cargando = ref(false)
const error = ref('')
const exportando = ref(false)
const expandidos = ref<Set<number>>(new Set())

const factoresOrdenados = computed((): FactorConOrdinal[] => {
  if (!avance.value) return []
  return [...avance.value.factores as FactorConOrdinal[]].sort((a, b) => {
    const oa = a.ordinal ?? ''
    const ob = b.ordinal ?? ''
    if (oa && ob) return oa.localeCompare(ob, undefined, { numeric: true })
    return (a.nombre ?? '').localeCompare(b.nombre ?? '', undefined, { numeric: true })
  })
})

const ESTADOS: Record<string, { texto: string; clase: string }> = {
  preparacion: { texto: 'Preparación', clase: 'p-gris' },
  ejecucion: { texto: 'Ejecución', clase: 'p-ambar' },
  evaluacion: { texto: 'Evaluación', clase: 'p-ambar' },
  informe: { texto: 'Informe', clase: 'p-verde' },
  finalizado: { texto: 'Finalizado', clase: 'p-verde' }
}

function estadoTexto(e: string): string {
  return ESTADOS[e]?.texto ?? e
}
function estadoClase(e: string): string {
  return ESTADOS[e]?.clase ?? 'p-gris'
}
function fmtPct(v: number | null): string {
  return v === null ? 'N/D' : `${v.toFixed(1)} %`
}
/** Dona de progreso (conic-gradient) para el % global calificado. */
function ringStyle(v: number | null): Record<string, string> {
  const grados = (v ?? 0) * 3.6
  return { background: `conic-gradient(#0e69a0 ${grados}deg, #e8f1f7 ${grados}deg)` }
}
function fmtFecha(iso: string): string {
  const d = new Date(iso)
  return isNaN(d.getTime()) ? iso : d.toLocaleString('es-CO')
}
function sinSemaforo(f: AvanceFactor): boolean {
  const s = f.semaforo_documental
  return !s.verde && !s.amarillo && !s.rojo
}
function toggleExpandir(id: number): void {
  const s = new Set(expandidos.value)
  s.has(id) ? s.delete(id) : s.add(id)
  expandidos.value = s
}

async function cargar(): Promise<void> {
  if (!props.idEjecucion) return
  cargando.value = true
  error.value = ''
  const r = await getAvanceProcesoService(props.idEjecucion)
  if (r.ok && r.data) {
    avance.value = r.data
  } else {
    error.value = r.error ?? 'No se pudo cargar el avance'
    avance.value = null
  }
  cargando.value = false
}

/** Aplana los factores a filas para las exportaciones tabulares. */
function filasExport(): Celda[][] {
  if (!avance.value) return []
  const pct = (v: number | null): Celda => (v === null ? 'N/D' : v)
  return avance.value.factores.map(f => [
    f.nombre,
    f.lider?.name ?? 'Sin líder',
    f.total_indicadores,
    f.calificados,
    pct(f.pct_calificados),
    pct(f.pct_fichas.documental),
    pct(f.pct_fichas.cuantitativa),
    pct(f.pct_fichas.opinion),
    f.semaforo_documental.verde,
    f.semaforo_documental.amarillo,
    f.semaforo_documental.rojo,
    f.pendientes.length
  ])
}

const HEADERS = [
  'Factor', 'Líder', 'Indicadores', 'Calificados', '% Calificados',
  '% Fichas documental', '% Fichas cuantitativa', '% Fichas opinión',
  'Doc. verde', 'Doc. amarillo', 'Doc. rojo', 'Pendientes'
]

function tabla() {
  return {
    nombre: `avance-proceso-${props.idEjecucion}`,
    titulo: 'Avance del proceso',
    headers: HEADERS,
    rows: filasExport()
  }
}

async function exportarExcelFn(): Promise<void> {
  await exportarExcel(tabla())
}
function exportarCSVFn(): void {
  exportarCSV(tabla())
}
async function descargarPdf(): Promise<void> {
  exportando.value = true
  await descargarPdfAvanceService(props.idEjecucion)
  exportando.value = false
}

onMounted(cargar)
watch(() => props.idEjecucion, cargar)

return (_ctx: any,_cache: any) => {
  const _directive_drag_scroll = _resolveDirective("drag-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Cargando avance del proceso…"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
        : (avance.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, _toDisplayString(avance.value.programa ?? 'Institucional'), 1),
                    (avance.value.campus)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(avance.value.campus), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", null, "Periodo " + _toDisplayString(avance.value.periodo), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["pill", estadoClase(avance.value.estado)])
                  }, _toDisplayString(estadoTexto(avance.value.estado)), 3)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: exportando.value,
                    onClick: exportarExcelFn
                  }, "Exportar Excel", 8, _hoisted_7),
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: exportando.value,
                    onClick: exportarCSVFn
                  }, "Exportar CSV", 8, _hoisted_8),
                  _createElementVNode("button", {
                    class: "btn primario",
                    disabled: exportando.value,
                    onClick: descargarPdf
                  }, _toDisplayString(exportando.value ? 'Generando…' : 'Descargar PDF'), 9, _hoisted_9)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "gp-ring",
                    style: _normalizeStyle(ringStyle(avance.value.global.pct_calificados))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(fmtPct(avance.value.global.pct_calificados)), 1)
                  ], 4),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gp-lbl" }, "Indicadores calificados", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(avance.value.global.calificados) + " de " + _toDisplayString(avance.value.global.total_indicadores) + " indicadores", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "gf-lbl" }, "Fichas documentales", -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(fmtPct(avance.value.global.pct_fichas.documental)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: "barra-rel",
                        style: _normalizeStyle({ width: (avance.value.global.pct_fichas.documental ?? 0) + '%' })
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gf-lbl" }, "Fichas cuantitativas", -1)),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(fmtPct(avance.value.global.pct_fichas.cuantitativa)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: "barra-rel",
                        style: _normalizeStyle({ width: (avance.value.global.pct_fichas.cuantitativa ?? 0) + '%' })
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "gf-lbl" }, "Fichas de opinión", -1)),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(fmtPct(avance.value.global.pct_fichas.opinion)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: "barra-rel",
                        style: _normalizeStyle({ width: (avance.value.global.pct_fichas.opinion ?? 0) + '%' })
                      }, null, 4)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_27, "Generado " + _toDisplayString(fmtFecha(avance.value.generado_en)) + " · datos calculados al momento de la consulta.", 1),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("table", _hoisted_29, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "col-num" }, "#"),
                      _createElementVNode("th", null, "Factor"),
                      _createElementVNode("th", null, "Líder"),
                      _createElementVNode("th", { class: "ctr" }, "% Calificados"),
                      _createElementVNode("th", { class: "ctr" }, "% Doc."),
                      _createElementVNode("th", { class: "ctr" }, "% Cuant."),
                      _createElementVNode("th", { class: "ctr" }, "% Opin."),
                      _createElementVNode("th", { class: "ctr" }, "Semáforo documental"),
                      _createElementVNode("th", { class: "ctr" }, "Pendientes")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factoresOrdenados.value, (f, idx) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: f.id_componente
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_30, _toDisplayString(f.ordinal ? formatOrdinal(f.ordinal) : (idx + 1)), 1),
                          _createElementVNode("td", null, _toDisplayString(f.nombre), 1),
                          _createElementVNode("td", null, [
                            (f.lider)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(f.lider.name), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_32, "Sin líder"))
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("div", {
                              class: "barra-fondo",
                              title: `${f.calificados}/${f.total_indicadores}`
                            }, [
                              _createElementVNode("div", {
                                class: "barra-rel",
                                style: _normalizeStyle({ width: (f.pct_calificados ?? 0) + '%' })
                              }, null, 4)
                            ], 8, _hoisted_34),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(fmtPct(f.pct_calificados)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(fmtPct(f.pct_fichas.documental)), 1),
                          _createElementVNode("td", _hoisted_37, _toDisplayString(fmtPct(f.pct_fichas.cuantitativa)), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(fmtPct(f.pct_fichas.opinion)), 1),
                          _createElementVNode("td", _hoisted_39, [
                            (f.semaforo_documental.verde)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(f.semaforo_documental.verde), 1))
                              : _createCommentVNode("", true),
                            (f.semaforo_documental.amarillo)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(f.semaforo_documental.amarillo), 1))
                              : _createCommentVNode("", true),
                            (f.semaforo_documental.rojo)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(f.semaforo_documental.rojo), 1))
                              : _createCommentVNode("", true),
                            (sinSemaforo(f))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "—"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_44, [
                            (f.pendientes.length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "chip-pendientes",
                                  onClick: ($event: any) => (toggleExpandir(f.id_componente))
                                }, _toDisplayString(f.pendientes.length) + " " + _toDisplayString(expandidos.value.has(f.id_componente) ? '▲' : '▼'), 9, _hoisted_45))
                              : (_openBlock(), _createElementBlock("span", _hoisted_46, "0"))
                          ])
                        ]),
                        (expandidos.value.has(f.id_componente))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                              _createElementVNode("td", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _cache[4] || (_cache[4] = _createElementVNode("b", null, "Indicadores pendientes de calificación", -1)),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.pendientes, (p) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: p.id_indicador
                                      }, [
                                        _createElementVNode("span", _hoisted_50, _toDisplayString(p.caracteristica), 1),
                                        _createTextVNode(" — " + _toDisplayString(p.enunciado), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (!factoresOrdenados.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_51, _cache[5] || (_cache[5] = [
                          _createElementVNode("td", {
                            colspan: "9",
                            class: "ctr nota"
                          }, "El proceso no tiene factores con estructura.", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])), [
                [_directive_drag_scroll]
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})